import { WebhookSubscriptionEventEnum } from '../types/webhook-settings-interface'

export const defaultEventTypesValues = Object.values(WebhookSubscriptionEventEnum).reduce(
  (acc, next) => {
    acc[next] = false
    return acc
  },
  {} as Record<WebhookSubscriptionEventEnum, boolean>,
)
